import type { FaireProductEntity } from "../../entity_types/product";

export const p_vp7umt9gxp: FaireProductEntity = {
  token: "p_vp7umt9gxp",
  type: "product",
  name: "Rodeo Margarita Frozen Cocktail -Just add Water + Tequila",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/9cde93687110503b83ebb1d4eb6c16e510fbf94caf55abed9f730a59e74a3d95.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67b104ce1b0d77f659180e740ab3174eac610de106724c4790fe2204e86e4d8b.jpeg",
    "https://cdn.faire.com/fastly/0be47d5d6f332756a58ca6c34e6ad58dce7693d5c2c304e65044a8d1063b112f.jpeg",
    "https://cdn.faire.com/fastly/36c3cd10a879a356e32f4eaf772edfc674beeb630afa3ba9344d07c978cf6252.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Yeehaw! Our rodeo margarita is perfect for your next tailgate, concert pregame or backyard BBQ. Saddle up and pour a round — Rodeo Margarita is made for kicking up dust and raising a glass\n\nFrozen Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 12oz Tequila and 36oz water shake or stir and throw in the freezer. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party. Cheers from Noble Mick's\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA 🇺🇸\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and design makes merchandising a breeze!",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:05.059Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
